<form #priceListCheckForm="ngForm" class="form-container">
    <div class="form-header">
        <div class="form-breadcrumb">
            <h3><a [routerLink]="['/pricelist']">Price List</a> > {{ pricelist.name || 'Create' }}</h3>
        </div>
        <div class="form-actions">
            <button *ngIf="!isFormDisabled" [disabled]="onSaveDisable" type="submit" mat-flat-button color="primary" (click)="save(priceListCheckForm.valid)">
                <mat-icon>save</mat-icon> Save
            </button>
            <button *ngIf="isFormDisabled" type="button" mat-stroked-button (click)="edit()">
                <mat-icon>edit</mat-icon> Edit
            </button>
            <button *ngIf="isFormDisabled" type="button" mat-flat-button color="primary" (click)="create()">
                <mat-icon>add</mat-icon> Create
            </button>
            <button *ngIf="!isFormDisabled" type="button" mat-stroked-button (click)="discardChanges()">Discard</button>
        </div>
    </div>
    <div class="form-card">
        <fieldset [disabled]="isFormDisabled">
            <div class="row">
                <div class="col-sm-4 mb-3">
                    <mat-form-field appearance="fill" class="w-100">
                        <mat-label>List Name</mat-label>
                        <input #name="ngModel" type="text" matInput name="name" [(ngModel)]="pricelist.name" required>
                        <mat-error *ngIf="name.invalid">List name is required</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </fieldset>

        <div>
            <div *ngIf="showTable" class="row mb-3">
                <div class="col-sm-5">
                    <mat-form-field appearance="fill" class="w-100">
                        <mat-label>Search Products</mat-label>
                        <input matInput type="text" (keyup)="doFilter($event)">
                        <mat-icon matSuffix>search</mat-icon>
                    </mat-form-field>
                </div>
            </div>
            <fieldset [disabled]="isFormDisabled">
                <table *ngIf="showTable" mat-table matSort [dataSource]="dataSource" class="mat-elevation-z2">

                    <ng-container  matColumnDef="name">
                        <th class="col-8" mat-header-cell *matHeaderCellDef>Product Name</th>
                        <td mat-cell *matCellDef="let element"> {{element.product_name}} </td>
                    </ng-container>
                    <ng-container  matColumnDef="rate">
                        <th class="col-4" mat-header-cell *matHeaderCellDef>Rate</th>
                        <td mat-cell *matCellDef="let element; let index = index">
                            <input name="rate-{{index}}" [(ngModel)]="element.rate" (keypress)="onlyNumber($event)" (focusout)="onFocusOut(element.product.id, element.rate)" type="text">
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                </table>
            </fieldset>
        </div>
    </div>

    <app-audit-log-viewer model="pricelist" [recordId]="pricelist.id"></app-audit-log-viewer>
</form>